<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="用户信息" name="first">
                <MarsUser></MarsUser>
            </el-tab-pane>
            <el-tab-pane label="公告信息" name="second">
                <MarsNotice></MarsNotice>
            </el-tab-pane>
            <el-tab-pane label="邮件信息" name="third">
                <MarsEmail></MarsEmail>
            </el-tab-pane>
            <el-tab-pane label="货币记录" name="fourth">
                <MarPriceRecord></MarPriceRecord>
            </el-tab-pane>
            <el-tab-pane label="货币修改" name="sixth">
                <MarsAddPriceRecord></MarsAddPriceRecord>
            </el-tab-pane>
            <el-tab-pane label="封禁用户" name="serven">
                <MarsManager></MarsManager>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import MarsUser from './MarsUser.vue';
import MarsEmail from '@/components/page/gamemanager/mars/MarsEmail.vue';
import MarsNotice from '@/components/page/gamemanager/mars/MarsNotice.vue';
import MarPriceRecord from '@/components/page/gamemanager/mars/MarPriceRecord.vue';
import MarsAddPriceRecord from '@/components/page/gamemanager/mars/MarsAddPriceRecord.vue';
import MarsManager from '@/components/page/gamemanager/mars/MarsManager.vue';

export default {
    name: 'Marspark',
    components: {
        MarsUser,
        MarsEmail,
        MarsNotice,
        MarPriceRecord,
        MarsAddPriceRecord,
        MarsManager
    },
    data: function(){
        return {
            activeName: 'first'
        }
    },
    created() {
        
    },
    methods: {
        handleClick(tab, event) {
            
        }
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>